import * as React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  hasDecimals: boolean;
}

export const CurrencyFormat = React.forwardRef<NumericFormatProps, CustomProps>(
  function CurrencyFormat(props, ref) {
    const { onChange, hasDecimals, ...other } = props;

    const isInputAllowed = (inputObj: any) => {
      const { value } = inputObj;
      // If hasDecimals is false, block input if it includes a decimal point
      return !(!hasDecimals && value.includes("."));
    };

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString={true}
        decimalScale={hasDecimals ? 2 : 0}
        isAllowed={isInputAllowed}
      />
    );
  }
);
